import { computed, defineComponent, ref } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import { Cell, Col, Icon as VanIcon, NavBar as VanNavBar, Row } from 'vant'
import { useAuthGuard } from '@/composables/use-auth-guard'
import { useInfiniteScroll } from '@/composables/use-infinite-scroll'
import { getApiV1UserFan, getApiV1UserFollowers } from '@/api/sdk.gen'
import type { FanItem } from '@/api/types.gen'
import emptyImg from '@/assets/empty-data.png'
import UserAvatar from '@/components/user-avatar'

export default defineComponent({
  name: 'MyFansPage',
  setup() {
    const route = useRoute()
  const goBack = useSmartBack()
    useAuthGuard()

    // ?userId= 存在则查指定用户的粉丝列表（"ta 的粉丝"）；不传则走旧的"我的粉丝"接口
    const targetUserId = computed(() => Number(route.query.userId) || 0)
    const isOther = computed(() => targetUserId.value > 0)
    const navTitle = computed(() => (isOther.value ? 'ta的粉丝' : '我的粉丝'))

    const keyword = ref('')

    const { items, isEmpty, load } = useInfiniteScroll<FanItem>(async (page, size) => {
      const res = isOther.value
        ? await getApiV1UserFollowers({
            query: { page, size, user_id: targetUserId.value },
          })
        : await getApiV1UserFan({ query: { page, size } })
      const data = res.data as { code: number; data: { list: FanItem[]; total: number } }
      return data.code === 0 ? data.data : { list: [], total: 0 }
    })

    load()

    const filtered = computed(() => {
      const k = keyword.value.trim()
      if (!k) return items.value
      return items.value.filter((u) => u.nickname?.includes(k))
    })

    /** 粉丝列表的一行 */
    const renderFan = (user: FanItem) => (
      <Cell key={user.id} class="list-item">
        {{
          icon: () => (
            <RouterLink class="btn-reset" to={`/user/${user.user_id}`}>
              <UserAvatar size="0.84rem" src={user.avatar} />
            </RouterLink>
          ),
          title: () => <div>{user.nickname}</div>,
        }}
      </Cell>
    )

    return () => (
      <div class="mycare-wrap">
        <VanNavBar title={navTitle.value} fixed>
          {{
            left: () => (
              <VanIcon name="arrow-left" color="#333" size="16" onClick={() => goBack()} />
            ),
          }}
        </VanNavBar>

        <div class="searcha">
          <Row align="center">
            <Col span={21}>
              <input
                placeholder="搜索粉丝昵称"
                value={keyword.value}
                onInput={(e: Event) => (keyword.value = (e.target as HTMLInputElement).value)}
              />
            </Col>
            <Col span={3}>
              <span>搜索</span>
            </Col>
          </Row>
        </div>

        <div class="van-pull-refresh">
          {filtered.value.map(renderFan)}

          {isEmpty.value && (
            <div class="text-center pt-[0.4rem] pb-[0.4rem]">
              <img src={emptyImg} class="w-[1.28rem]" alt="" />
              <p class="text-center text-[#a0a0a0] text-[0.32rem] leading-[0.44rem] mt-[0.28rem]">
                暂无粉丝
              </p>
            </div>
          )}
        </div>
      </div>
    )
  },
})
